
























































































































import Vue from 'vue';
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

export default Vue.extend({
  name: 'Avatar',
  data: () => ({
    profile: false
  }),

  computed: {
    authProvider(): any {
      return authProvider(this.$store);
    }
  },

  methods: {
    signOut() {
      this.authProvider.logout().finally(() => {
        // The accounts-lib logout only clears access__token and user. Explicitly
        // remove refresh__token so a token stored by a previous Microsoft SSO
        // session cannot be picked up by the refresh interceptor in the next session.
        localStorage.removeItem('refresh__token');
        this.$router.push({ name: 'sign-in' });
      });
    }
  },

  watch: {
    // set the menu to false when route changes
    '$route.path': {
      handler() {
        this.profile = false;
      }
    }
  },

  mounted() {
    // get current user based on localstorage token user
    if (this.authProvider.isLoggedin) {
      return (this as any).authProvider.fetchMe();
    }
  }
});
